import script from "./DecaWizardProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./DecaWizardProgress.vue?vue&type=script&setup=true&lang=js"

import "./DecaWizardProgress.vue?vue&type=style&index=0&id=bf9d0e98&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf9d0e98"]])

export default __exports__